// imports
import { Box, Tab, Tabs, Typography } from '@mui/material';
import { FC, useState } from 'react';

// components
import TabPanel from 'components/common/TabPanel';
import ChangePasswordForm from 'components/main/ChangePassword/ChangePasswordForm';
import Profile from '../Profile';
import Invoice from './Invoice';
import PaymentMethods from './PaymentMethods';

// constants helpers interfaces
import { BillingIcon, PasswordIcon, PaymentIcon, ProfileIcon } from 'assets/svgs';
import {
  CHANGE_PASSWORD_TEXT,
  INVOICES_TEXT,
  PROFILE_TEXT,
  SETTINGS_TEXT,
  SettingsTabs,
  SUBSCRIPTION_TEXT,
} from 'constants/index';
import { useAuthContext } from 'contexts/AuthContext';
import { isAdmin, isAdminOrStaff } from 'lib/helper';

const Settings: FC = () => {
  const [value, setValue] = useState(SettingsTabs.PROFILE);
  const { userRoles } = useAuthContext();
  const adminOrStaff = isAdminOrStaff(userRoles);
  const admin = isAdmin(userRoles);

  const handleChange = (_: React.SyntheticEvent, newValue: SettingsTabs) => {
    setValue(newValue);
  };

  return (
    <Box mb={2}>
      <Typography variant="h5" mb={1}>
        {SETTINGS_TEXT}
      </Typography>
      <Tabs value={value} onChange={handleChange} aria-label="wrapped label tabs example">
        <Tab value={SettingsTabs.PROFILE} label={PROFILE_TEXT} icon={ProfileIcon} iconPosition="start" />
        {adminOrStaff && (
          <Tab
            value={SettingsTabs.SUBSCRIPTION}
            label={SUBSCRIPTION_TEXT}
            icon={PaymentIcon}
            wrapped
            iconPosition="start"
          />
        )}
        {admin && (
          <Tab value={SettingsTabs.INVOICES} label={INVOICES_TEXT} icon={BillingIcon} iconPosition="start" />
        )}
        <Tab
          value={SettingsTabs.CHANGE_PASSWORD}
          label={CHANGE_PASSWORD_TEXT}
          icon={PasswordIcon}
          iconPosition="start"
        />
      </Tabs>
      <TabPanel value={SettingsTabs.PROFILE} activeTab={value}>
        <Profile />
      </TabPanel>
      <TabPanel value={SettingsTabs.SUBSCRIPTION} activeTab={value}>
        <PaymentMethods />
      </TabPanel>
      <TabPanel value={SettingsTabs.INVOICES} activeTab={value}>
        <Invoice />
      </TabPanel>

      <TabPanel value={SettingsTabs.CHANGE_PASSWORD} activeTab={value}>
        <ChangePasswordForm />
      </TabPanel>
    </Box>
  );
};

export default Settings;
